import { PencilSquareIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import React from "react";

interface IProps {
  buttonText?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  styles?: { paddingX?: string };
}

export default function EditButton({
  onClick,
  buttonText = "Edit",
  className = "",
  styles = { paddingX: "px-4" },
}: IProps) {
  return (
    <button
      type="button"
      className={classNames(
        `text-gray-500 text-xs font-medium flex items-center justify-end w-full ${styles?.paddingX}`,
        className
      )}
      onClick={onClick}
    >
      <PencilSquareIcon className="w-4 h-4 text-gray-500 mr-2" />
      {buttonText}
    </button>
  );
}
